import { useEffect } from "react";
import { trackEvent } from "../lib/engagement";

export function usePageView(route: string) {
  useEffect(() => {
    trackEvent("page_view", { route });
  }, [route]);
}
